import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6e74a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "callback-container" }
const _hoisted_2 = { class: "callback-content" }
const _hoisted_3 = {
  key: 0,
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "mt-3" }

import { onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
import { useI18n } from "vue-i18n";


const __default__ = {
  name: "CallbackPage",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {t} = useI18n();
const router = useRouter();
const route = useRoute();
const isProcessing = ref(true);
const errorMessage = ref<string | null>(null);

onMounted(async () => {
  try {
    //loop prevention
    const callbackProcessed = sessionStorage.getItem("msal-callback-processed");
    if (callbackProcessed === "true") {
      const redirectTo = route.query.to ? String(route.query.to) : "/home";
      router.replace(redirectTo);
      return;
    }
    
    sessionStorage.setItem("msal-callback-processed", "true");
    
    // waiting for main.ts to finish processing redirect
    
    await new Promise((resolve) => setTimeout(resolve, 500));
    
    //checking if user data exists (set by main.ts)
    const userDataStr = localStorage.getItem("user");
    
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        
        // Update Vuex store - commit loginSuccess which sets state and redirects to /home
        // We'll override the redirect immediately after
        store.commit("authentication/loginSuccess", userData);
        
        //clearing flags
        sessionStorage.removeItem("msal-redirect-in-progress");
        sessionStorage.removeItem("msal-callback-processed");
        
        //redirecting to home or intended route (overrides the /home redirect from mutation)
        const redirectTo = route.query.to ? String(route.query.to) : "/home";
        //using replace to avoid adding to history
        await router.replace(redirectTo);
      } catch (parseError) {
        console.error("Error parsing user data:", parseError);
        errorMessage.value = t("Teller.ErrorProcessingUserData");
        sessionStorage.removeItem("msal-redirect-in-progress");
        sessionStorage.removeItem("msal-callback-processed");
        router.replace({ path: "/login", query: { error: "parse_error" } });
      }
    } else {
      //auth failed -> no user data found in ls
      errorMessage.value = t("Teller.AuthenticationFailed");
      sessionStorage.removeItem("msal-redirect-in-progress");
      sessionStorage.removeItem("msal-callback-processed");
      router.replace({ path: "/login", query: { error: "authentication_failed" } });
    }
  } catch (error) {
    console.error("Error in callback:", error);
    errorMessage.value = t("Teller.AnErrorOccurredDuringAuthentication");
    sessionStorage.removeItem("msal-redirect-in-progress");
    sessionStorage.removeItem("msal-callback-processed");
    router.replace({ path: "/login", query: { error: "callback_error" } });
  } finally {
    isProcessing.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isProcessing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_6, _toDisplayString(isProcessing.value ? _unref(t)("Teller.ProcessingAuthentication") : (errorMessage.value || _unref(t)("Teller.AuthenticationSuccessful"))), 1)
    ])
  ]))
}
}

})